import React, { Component } from "react";
import "./Header.scss";
import IconAndTitle from "../IconAndTitle/IconAndTitle";
import HeaderDate from "../HeaderDate/HeaderDate";
// import HeaderHelp from "../HeaderHelp/HeaderHelp";
import MenuButton from "../MenuButton/MenuButton";
// import HeaderNotification from "../HeaderNotification/HeaderNotification";
import User from "../User/User";

class Header extends Component {
  backgroundClass = () => {
    let environment = JSON.parse(localStorage.getItem("environment"));

    if (!environment) {
      return "page-header-background-color";
    } else {
      return (
        "page-header-background-color-" +
        environment.environmentType.toLowerCase()
      );
    }
  };

  render() {
    return (
      <div className={"header page-header-color " + this.backgroundClass()}>
        <div className="left-elements">
          <MenuButton />
          <IconAndTitle />
        </div>
        <div className="right-elements">
          <HeaderDate idleTimer={this.props.idleTimer} />
          {/* <HeaderHelp /> */}
          {/* <HeaderNotification /> */}
          <User />
        </div>
      </div>
    );
  }
}

export default Header;
